import { MenuLink as themeMenuLink } from '@lucid/gatsby-theme-lucid/utils/getDrupalMenu';

import {
  Drupal,
  Drupal_Entity,
  Drupal_Metatag,
  Drupal_ParagraphMarketoForm,
  FileConnection
} from '../generated/graphql';

export interface PageContext {
  nid: string;
  langPrefix: string;
  LanguageId: string;
  i18nKey: string;
  pageType: string;
  extraData: string;
  entityChanged?: string;
  excludeFromSitemap?: boolean;
}

export interface TemplateProps {
  data: {
    drupal: Drupal;
    i18nData?: FileConnection;
  };
  pageContext: PageContext;
  location: any;
}

export interface MenuLink extends themeMenuLink {
  type?: string;
  truncate?: boolean;
  fieldLinkPhoneNumber?: string;
  fieldKey?: string;
  fieldAnalyticsEventName?: string;
  fieldMarketo?: {
    entity: Drupal_ParagraphMarketoForm;
  };
  links: MenuLink[];
}

export interface ExtraData {
  marketoForms: any[];
  metatags: Drupal_Metatag[];
  otherTranslationData: Drupal_Entity[];
  navbarMenu: any;
  footerMenu: any;
}

export function isDefined<T extends object>(
  input: null | undefined | T | string
): input is T {
  return input != null;
}

export enum Template {
  Assignment = 'assignment',
  Homepage = 'case_study_hub',
  Consideration = 'homepage',
  IntegrationsPage = 'integrations_page',
  Nineteen = 'nineteen'
}

declare global {
  interface Window {
    _wq: any;
    drift: any;
    Wistia: any;
    lucid: any;
  }
}
